module.exports = __webpack_public_path__ + "img/nature-9.ecdaf8ad.jpg";